import { DIMENSIONS } from './dimensions.constant.js';
export const LOOKER_FILTERS = [
    ...DIMENSIONS,
    'brand_key',
    'brand_type_key',
    'chain_type',
    'class_key',
    'country_key',
    'department_key',
    'grp_class_key',
    'sector_key',
    'store_int_flag',
    'sub_class_key',
    'country_filter',
    'store_region_key',
    'date_filter',
    'date_granularity_filter',
    'detention_window',
    'period_code',
    'nielsen_period_filter_current',
    'nielsen_period_filter_previous',
    'numerator_key',
    'sales_with_or_without_tax',
    // Like 4 like
    'is_eligible',
    'store_open_days_percent',
    // Competitors
    'barcode_anonymized',
    'brand_desc_anonymized',
    'brand_key_anonymized',
    'competitor_key_anonymized',
    'competitor_desc_anonymized',
    'competitor_supplier_root_key',
    'include_supplier_data',
    'item_key_anonymized',
    'item_desc_anonymized',
    'perimeter_main_holding_key',
    'perimeter_bem_merchandise_key',
    'perimeter_supplier_key',
    'supplier_root_desc_anonymized',
    'supplier_root_key_anonymized',
    'filter_supplier_root_desc',
    //Dynamic Client
    'promo_flag_desc',
    'destination_analysis_type',
    'comparaison_date_range',
    'compare_to',
    // Customer Segmentation
    'view_type',
    'shopper_seg_type',
    'shopper_seg_granularity',
    'consostyle_macro_key',
    'consostyle_micro_key',
    'not_in_consostyle_micro_key',
    'not_in_trad_consostyle_micro_distribution',
    'not_in_trad_consostyle_macro_distribution',
    'trad_consostyle_macro_distribution',
    'trad_consostyle_micro_distribution',
    'lifestage_macro_key',
    'lifestage_micro_key',
    'not_in_lifestage_micro_key',
    'not_in_trad_lifestage_micro_distribution',
    'not_in_trad_lifestage_macro_distribution',
    'trad_lifestage_macro_distribution',
    'trad_lifestage_micro_distribution',
    'segment_dim_type',
    // Business Brand
    'business_brand',
    'business_brand_reduced',
    // BEL
    'bem_merchandise_key'
];
//# sourceMappingURL=lookerFilters.constant.js.map